var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24-.003V8H12L0-.003h24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 8v8.003H0L12 8h12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.59 8l-1.283-.6.683-1.238-1.388.263-.172-1.403-.968 1.028-.967-1.028-.18 1.403-1.388-.263L2.61 7.4 1.327 8l1.283.6-.683 1.237 1.388-.262.18 1.402.967-1.035.968 1.035.172-1.402 1.388.262L6.307 8.6 7.59 8zM1.02 1.512l.427.593.698-.218-.435.585.427.6-.697-.232-.435.585.007-.728-.697-.232.697-.218.008-.735zm0 11.063l.427.593.698-.225-.435.592.427.592-.697-.232-.435.593.007-.736-.697-.225.697-.224.008-.728zM9.862 7.04l-.427.6-.698-.225.435.592-.427.593.697-.233.435.593-.007-.735.697-.233-.697-.217-.008-.735z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.73f9b22413c85602f3a52fad94651446.svg";
export { ForwardRef as ReactComponent };